module.exports = __webpack_public_path__ + "img/3.83ae87b0.jpg";